import qs from "query-string";
import { getDefaultUrl } from "../redirect/getDefaultUrl";
export const urlStringToObject = (string) => qs.parse(string, { ignoreQueryPrefix: true });
export const urlObjectToString = (object) => qs.stringify(object);
export const addSearchParams = (url, newParams, config) => {
    if (typeof url === "string") {
        if (url === "/") {
            url = getDefaultUrl(config);
        }
        if (url.includes("?")) {
            url = url.concat(`&${urlObjectToString(newParams)}`);
        }
        else {
            url = url.concat(`?${urlObjectToString(newParams)}`);
        }
    }
    else if (typeof url === "object") {
        const oldParams = urlStringToObject(url.search);
        const params = Object.assign(Object.assign({}, oldParams), newParams);
        url.search = `?${urlObjectToString(params)}`;
        if (url.pathname === undefined && window.location.href.substr(-1) === "/") {
            url.pathname = getDefaultUrl(config);
        }
    }
    return url;
};
//# sourceMappingURL=index.js.map